// extracted by mini-css-extract-plugin
export var chevron = "_f5-2";
export var dropdownItems = "_f5-0";
export var item = "_f5-1";